import React from 'react';
import { OBJECT_TYPE_NAME } from '../../constants/CODE_SNTS';
import { routeMap } from '../../../../../../router';
import LinkContainer from '../../../../../../containers/LinkWrapperContainer';

export const CODE_INCOME_SALE_REAL_ESTATE = 1510;
export const CODE_INCOME_SALE_SHARE = 1511;
export const CODE_INCOME_SALE_OTHER_REAL_ESTATE = 1512;
export const SHARE_MAX_RANGE = 999999;
export const COEFFICIENT = 0.7;

export const incomeLogicForYear = {
  initialIncomeFields: {
    cadastralNumberAlienatedEstateObject: '',
    soldObjectPurchasedAfter: false,
    soldObject: 0,
    cadastralValueDetermined: false,
    objectContractBuySaleCost: '',
    cadastralObjectCost: '',
    shareNumerator: '',
    shareDenominator: '',
    taxDeductionAmount: '',
  },
  initialIncomeFieldsClear: {
    cadastralNumberAlienatedEstateObject: '',
    soldObjectPurchasedAfter: false,
    soldObject: 0,
    cadastralValueDetermined: false,
    objectContractBuySaleCost: '',
    cadastralObjectCost: '',
    shareNumerator: '',
    shareDenominator: '',
    taxDeductionAmount: '',
  },

  /**
   * @param {number} shareNumerator
   * @param {number} shareDenominator
   * @returns {number}
   */
  getShare(shareNumerator, shareDenominator) {
    if (shareNumerator && shareDenominator) {
      return shareNumerator / shareDenominator;
    }
    return 1;
  },

  /**
   * @param {number|string} value
   * @returns {number}
   */
  formatResultIncome(value) {
    let val = Number(value);
    let res = value.toString().split('.');
    if (res.length > 1) {
      val = val.toFixed(2);
    }
    return parseFloat(val);
  },

  /**
   * @param {number} objectContractBuySaleCost
   * @param {number} cadastralObjectCost
   * @param {number} [share=1]
   * @returns {*}
   */
  calculateIncomeSale(objectContractBuySaleCost, cadastralObjectCost, share = 1) {
    const cadastralCost = cadastralObjectCost * COEFFICIENT * share;

    if (objectContractBuySaleCost && cadastralObjectCost) {
      return objectContractBuySaleCost > cadastralCost
        ? this.formatResultIncome(objectContractBuySaleCost)
        : this.formatResultIncome(cadastralCost);
    }
    if (objectContractBuySaleCost && !cadastralObjectCost) {
      return this.formatResultIncome(objectContractBuySaleCost);
    }
    if (!objectContractBuySaleCost && cadastralObjectCost) {
      return this.formatResultIncome(cadastralCost);
    }
    return '';
  },

  /**
   * @param {Array<{id: number, propertyType: number, cadastralNumber: string, address: string, isHouse: Function}>} data
   * @returns {Array<{label: string, value: number, cadastralNumber: string}>}
   */
  getOptionsForObjectList(data) {
    const objectList = data
      .filter((propertyObject) => {
        return propertyObject.isHouse();
      })
      .map((propertyObject) => {
        return {
          label: OBJECT_TYPE_NAME[propertyObject.propertyType] + ', ' + propertyObject.address,
          value: propertyObject.id,
          cadastralNumber: propertyObject.cadastralNumber,
        };
      })
      .toArray();
    objectList.push({
      label: 'Другой объект',
      value: 0,
      cadastralNumber: '',
    });
    return objectList;
  },
};

/**
 * @param {number} incomeCode
 * @returns {boolean}
 */
export function isIncomeSaleRealEstateOrShare(incomeCode) {
  return [
    CODE_INCOME_SALE_REAL_ESTATE,
    CODE_INCOME_SALE_SHARE,
    CODE_INCOME_SALE_OTHER_REAL_ESTATE,
  ].includes(incomeCode);
}

/**
 * @param {number} year
 * @returns {boolean}
 */
export function displayForOldYear(year) {
  return year === 2014;
}

export function showYearNotification(year) {
  let notification = null;
  if (year === 2014) {
    notification = (
      <span className={'Step1UserData__oldLink'}>
        Подать декларацию за выбранный период вы можете в старом &nbsp;
        <LinkContainer href={`${routeMap.externalServices}?type=lkfl20`} target="_blank">
          Личном кабинете
        </LinkContainer>
      </span>
    );
  }

  return notification;
}
